import React from "react";

export default function MPHeader3() {
  return (
    <div
      style={{
        width: "100%",
        //backgroundColor: "#a5f3fc",
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        paddingBottom: 10,
      }}
    ></div>
  );
}
